import {InjectionToken} from '@angular/core';
import {Restangular} from 'ngx-restangular';

export const RESTANGULAR_INTEGRATION_SERVER = new InjectionToken<Restangular>('RestangularIntegration');
